module.exports = __webpack_public_path__ + "epdf-app/dashboard/batch/batch-3HgsvB-_.html";